/*       */

import React, { Component } from 'react';
import PageTemplate from 'app/components/templates/PageTemplate';
import IFrame from 'app/components/atoms/IFrame/IFrame';

/**
 * Renders the view to display the classification.
 */
class Chart extends Component {
    /**
     * @override
     */
    render() {
        return (
            <PageTemplate title="Pentaho CE" overflowHidden hasIframe>
                <IFrame title="Pentaho CE" src="/pentaho"></IFrame>
            </PageTemplate>
        );
    }
}

export default Chart;
